module.exports = __webpack_public_path__ + "img/the-pallet-header-logo-main.d1da9c74.png";